document.addEventListener('DOMContentLoaded', () => {
  const accordionBtns = document.querySelectorAll<HTMLElement>('.js-accordion-toggle');

  accordionBtns.forEach((btn) => {
    // Grab panel
    const panel = btn.nextElementSibling as HTMLElement | null;
    if (!panel) {
      return;
    }

    const links = panel.querySelectorAll('a,iframe,button,input,video');

    disableLinks(links);

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (panel?.classList.contains('open')) {
        btn.classList.remove('open');
        panel.style.maxHeight = '';
        panel.classList.remove('open');
        panel.setAttribute('aria-hidden', 'true');
        disableLinks(links);
      } else if (panel) {
        btn.classList.add('open');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        panel.classList.add('open');
        panel.removeAttribute('aria-hidden');
        enableLinks(links);
      }
    });
  });
});

function disableLinks(links) {
  links.forEach((link) => {
    link.setAttribute('tabindex', '-1');
  });
}

function enableLinks(links) {
  links.forEach((link) => {
    link.setAttribute('tabindex', '0');
  });
}
